/*
 * @Author: RONGWEI PENG
 * @Date: 2021-11-03 14:10:06
 * @LastEditors: Do not edit
 * @LastEditTime: 2021-11-05 12:33:26
 * @FilePath: /dsf-product-nc/packages/@dsf/cli-nc/pc/components/live/index.js
 */
import live from "./live";
import liveTitle from "./liveTitle";
import recentLive from "./recentLive";
import liveDetail from "./liveDetail";
import cardItemByLive from "./cardItemByLive";
import cardItemByWonderfulLive from "./cardItemByWonderfulLive";
import livesignin from "./livesignin";
import liveInformation from "./liveInformation";

export default [livesignin, live, recentLive, liveTitle, liveDetail, cardItemByLive, cardItemByWonderfulLive, liveInformation];
